export const config = {
    "SERVER_URL": process.env.REACT_APP_API_URL,
    "APP_URL_HOST": process.env.REACT_APP_URL_HOST,
    "CDN_URL": process.env.REACT_APP_CDN_URL,
};

export const generateUUID = () => {
    let uniqueId = Date.now().toString(36) + '-' + Math.random().toString(36).substring(2);
    return uniqueId;

}

export const generateTimeStr = () => {
    let uniqueId = Date.now().toString(36);
    return uniqueId;

}

export const extractDateFromTimeStr = (timeStr) => {

    const timestampPart = timeStr;
    const timestamp = parseInt(timestampPart, 36);

    return new Date(timestamp);
};

export const QuizSubject = Object.freeze({
    GENERAL: "General",
    ALBUMS: "Albums",
    SONGS: "Songs",
    MATCH_SONGS_TO_ALBUMS: "Match Songs To Albums",
    COMPLETE_TITLES: "Complete the Song titles",
    COLLABORATIONS: "Collaborations",
    QUOTES: "Quotes",
    DEEP_CUTS: "Deep Cuts",
    PERSONAL_LIFE: "Personal Life",
    AWARDS: "Awards & Achievements",
    MEMBERS: "Members",
    EARLY_YEARS: "Early Years",
    TOURS: "Tours & Live Shows",
    SPECIFIC_ALBUM: "Specific album",
    SPECIFIC_SONG: "Specific Song",
    OTHER: "Other"
});

export const QuestionCategory = Object.freeze({
    ALL: "ALL",
    INCEPTION: "INCEPTION",
    MEMBERS: "MEMBERS",
    SONGS: "SONGS",
    ALBUMS: "ALBUMS",
    GENRE: "GENRE",
    PERSONAL_DETAILS: "PERSONAL_DETAILS",
    GENERAL: "GENERAL",
    ACCOLADES: "ACCOLADES",
    SONGS_ALBUMS: "SONGS_ALBUMS",
    TOURS: "TOURS"
});

export const CATEGORY_MAP = Object.freeze({
    [QuizSubject.GENERAL]: [QuestionCategory.ALL],
    [QuizSubject.ALBUMS]: [QuestionCategory.ALBUMS, QuestionCategory.SONGS_ALBUMS],
    [QuizSubject.AWARDS]: [QuestionCategory.ACCOLADES],
    [QuizSubject.COLLABORATIONS]: null,
    [QuizSubject.COMPLETE_TITLES]: null,
    [QuizSubject.DEEP_CUTS]: [QuestionCategory.SONGS, QuestionCategory.ALBUMS, QuestionCategory.SONGS_ALBUMS],
    [QuizSubject.EARLY_YEARS]: [QuestionCategory.PERSONAL_DETAILS, QuestionCategory.INCEPTION],
    [QuizSubject.MATCH_SONGS_TO_ALBUMS]: [QuestionCategory.SONGS_ALBUMS],
    [QuizSubject.MEMBERS]: [QuestionCategory.MEMBERS],
    [QuizSubject.PERSONAL_LIFE]: [QuestionCategory.PERSONAL_DETAILS],
    [QuizSubject.QUOTES]: [QuestionCategory.MEMBERS],
    [QuizSubject.SONGS]: [QuestionCategory.SONGS, QuestionCategory.SONGS_ALBUMS],
    [QuizSubject.SPECIFIC_ALBUM]: [QuestionCategory.ALBUMS, QuestionCategory.SONGS_ALBUMS, QuestionCategory.ACCOLADES],
    [QuizSubject.SPECIFIC_SONG]: [QuestionCategory.SONGS, QuestionCategory.SONGS_ALBUMS, QuestionCategory.ACCOLADES],
    [QuizSubject.TOURS]: null,

});



export const LOCK_ASPECT_DIS_DAT = { aspect: 1, minWidth: 400 };
export const LOCK_ASPECT_SHARE = { aspect: 1.905, minWidth: 1200 };
export const LOCK_ASPECT_START_QUIZ = { aspect: 1.3, minWidth: 600 };
export const LOCK_ASPECT_QUESTION = { aspect: 1.6, minWidth: 400 };
export const LOCK_ASPECT_PINTEREST = { aspect: 0.6666, minWidth: 700 };
export const IMAGE_SELECTOR_IN_QUIZ_METADATA = 0;
export const IMAGE_SELECTOR_IN_QUIZ_QUESTION = 1;

export const MODE_PUBLISH = 0;
export const MODE_UNPUBLISH = 1;
